import * as list from './list';
import * as citiesOfCountry from './citiesOfCountry';

export default {
  ...list,
  ...citiesOfCountry,
};
